<template>
  <div class="addattr">
    <el-card class="card">
      <div slot="header"
           class="clearfix">
        <span>{{ $t('deviceProperty.createExAttr') }}</span>
      </div>
      <el-form ref="data"
               :model="data"
               status-icon
               label-width="70px"
               class="demo-ruleForm"
               :rules="rules">
        <el-form-item :label="$t('deviceProperty.attrName')"
                      prop="attrName">
          <el-input v-model="data.attrName" size="mini"
                    :placeholder="$t('deviceProperty.enterAttrName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('deviceProperty.attrValue')"
                      prop="attrValue">
          <el-input v-model.number="data.attrValue" size="mini"
                    :placeholder="$t('deviceProperty.enterAttrValue')"></el-input>
        </el-form-item>
        <el-form-item class="btnmg">
        </el-form-item>
      </el-form>
      <div class="btnmg">
        <el-button type="primary" size="mini"
                    @click="submitForm('data')">{{ $t('dataInput.save') }}</el-button>
        <el-button size="mini" @click="resetForm('data')">{{ $t('dataInput.cancel') }}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
export default {
  name: 'addattr',
  props: ['modaldata'],
  data() {
    return {
      data: {
        attrName: '',
        attrValue: ''
      },
      rules: {
        attrName: [
          { required: true, message: this.$t('deviceProperty.enterAttrName'), trigger: 'blur' }
        ],
        attrValue: [
          { required: true, message: this.$t('deviceProperty.enterAttrValue'), trigger: 'blur' }
        ]
      },
      bit: null
    }
  },
  created() {
    console.log(this.modaldata)
  },
  methods: {
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            mileageID: window.R_config.modelId,
            BitNumber: window.Muster,
            propertyname: this.data.attrName,
            provalue: this.data.attrValue
          }
          if (this.modaldata) {
            params.ID = this.modaldata
          }
          // 上传新数据接口
          ApiService.tree.addextraprop(params).then(res => {
            if (res.code == '0') {
              this.getproperty()
              this.$refs[formName].resetFields()
              this.$store.commit('closeModal', 'addattr')
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 取消、关闭
    resetForm(formName) {
      if (formName) {
        this.$refs[formName].resetFields()
      }
      this.$store.commit('closeModal', 'addattr')
    },
    getproperty() {
      ApiService.tree
        .property({
          mileageID: window.R_config.modelId,
          BitNumber: window.Muster
        })
        .then(res => {
          if (res.code == 0) {
            let attrData = res.data
            this.$store.commit('syncAttrData', attrData)
            this.$message({
              message: '添加成功',
              type: 'success'
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.addattr {
  .card {
    width: 342px;
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2), 0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/addattr.vue